export const paymentGetters = {
    payment: (state) => state.payment,

    paymentAttemptCount(state) {
        return state.payment.attemptCount;
    },

    failedPaymentCount(state) {
        return state.payment.failedCount;
    },

    captchaValue(state) {
        return state.payment.captchaValue;
    },

    captchaKey(state) {
        return state.payment.captchaKey;
    },

    tncAccepted(state) {
        return state.payment.tncAccepted;
    },

    showPayForm(state) {
        return state.payment.formVisible;
    },

    paymentErrors(state) {
        return state.payment.errors;
    },

    cvvEntered(state) {
        return state.payment.cvvEntered;
    },

    expEntered(state) {
        return state.payment.expEntered;
    },

    offlineSignupEnabled(state) {
        return state.payment.offlineSignup?.enabled
    },

    paymentFormInitialized(state) {
        return state.paymentFormInitialized
    },

    offlineSignup(state) {
        return state.payment.offlineSignup
    },

}
